// extracted by mini-css-extract-plugin
module.exports = {"link":"NonAttemptedTestsPlaceholder_link__puvW7"};